import type { Story } from "@theirstory/common/api_types/backend";
import * as Sentry from "@sentry/react";

import { buildFileNameForStory, forceDownloadOfUrl } from "../../utils/util";

export const downloadStory = (story: Story) => {
  try {
    forceDownloadOfUrl(story.archiveURL, buildFileNameForStory(story));
  } catch (err) {
    console.log(err);
    Sentry.withScope((scope) => {
      scope.setExtra("story", story);
      scope.setTag("storyId", story._id);
      scope.setTag("method", "downloadStory");
      Sentry.captureException(err);
    });
  }
};
